import React, { useState } from "react";
import "./EditChildModal.css";
import { doc, updateDoc, getDoc } from "firebase/firestore";
import { db } from "../firebase/config";

function EditParentModal({ parent, onClose, onSaved }) {
  const [name, setName] = useState(parent.name);
  const [pin, setPin] = useState(parent.pin);
  const [photo, setPhoto] = useState(parent.photo || "");

  const handleImageUpload = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    if (!file.type.startsWith("image/")) {
      alert("Будь ласка, виберіть зображення.");
      return;
    }

    const reader = new FileReader();
    reader.onload = (event) => {
      const img = new Image();
      img.onload = () => {
        const canvas = document.createElement("canvas");
        const maxSize = 300;
        let width = img.width;
        let height = img.height;

        if (width > height) {
          if (width > maxSize) {
            height *= maxSize / width;
            width = maxSize;
          }
        } else {
          if (height > maxSize) {
            width *= maxSize / height;
            height = maxSize;
          }
        }

        canvas.width = width;
        canvas.height = height;
        const ctx = canvas.getContext("2d");
        ctx.drawImage(img, 0, 0, width, height);

        const compressedBase64 = canvas.toDataURL("image/jpeg", 0.7);
        setPhoto(compressedBase64);
      };
      img.src = event.target.result;
    };

    reader.readAsDataURL(file);
  };

  const handleSave = async () => {
    const ref = doc(db, "users", parent.id);
    await updateDoc(ref, {
      name,
      pin,
      photo,
    });

    const updatedSnap = await getDoc(ref);
    const updatedData = { id: ref.id, ...updatedSnap.data() };
    localStorage.setItem("selectedUser", JSON.stringify(updatedData));

    onSaved();
    onClose();
  };

  return (
    <div className="modal-backdrop">
      <div className="modal-content">
        <h2>Редагування профілю</h2>

        <div className="form-row">
          <label>Ім’я:</label>
          <input value={name} onChange={(e) => setName(e.target.value)} />
        </div>

        <div className="form-row">
          <label>PIN-код:</label>
          <input
            type="text"
            value={pin}
            onChange={(e) => setPin(e.target.value)}
            maxLength={4}
            inputMode="numeric"
          />
        </div>

        <div className="form-row">
          <label>Фото профілю:</label>
          <input type="file" accept="image/*" onChange={handleImageUpload} />
        </div>

        {photo && (
          <div className="form-row" style={{ justifyContent: "center" }}>
            <img
              src={photo}
              alt="Прев’ю"
              style={{
                width: "100px",
                height: "100px",
                borderRadius: "50%",
                objectFit: "cover",
              }}
            />
          </div>
        )}

        <div className="modal-actions">
          <button onClick={handleSave}>Зберегти</button>
          <button className="cancel" onClick={onClose}>Скасувати</button>
        </div>
      </div>
    </div>
  );
}

export default EditParentModal;
